import _sfc_main from "./StreamContainerPC.vue2.mjs";
/* empty css                        */
import normalizeComponent from "../../../_virtual/_plugin-vue2_normalizer.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { class: _setup.streamContainerClass, attrs: { "id": "streamContainer" } }, [_setup.enlargeStream ? _c(_setup.SingleStreamView, { staticClass: "enlarged-stream-container", attrs: { "streamInfo": _setup.enlargeStream } }) : _vm._e(), _c(_setup.MultiStreamView, { class: ["stream-list-container", `${_setup.showSideList ? "" : "hide-list"}`], attrs: { "maxColumn": _setup.maxColumn, "maxRow": _setup.maxRow, "excludeStreamInfoList": _setup.excludeStreamInfoList }, on: { "stream-view-dblclick": _setup.handleStreamViewDblclick } }), _setup.isSideListLayout && (_setup.showRoomTool || _setup.showSideList) ? _c(_setup.ArrowStroke, { class: [`arrow-stroke-${_setup.arrowDirection}`], attrs: { "stroke-position": _setup.strokePosition, "arrow-direction": _setup.arrowDirection, "has-stroke": _setup.showSideList }, on: { "click-arrow": _setup.handleClickIcon } }) : _vm._e()], 1);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "d8393878"
);
const StreamContainerPc = __component__.exports;
export {
  StreamContainerPc as default
};
